<ng-container *transloco="let t; prefix: 'navigation.logoutConfirmationDialog'">
  @if (isModalOpen()) {
    <aml-dialog
      [title]="t('title')"
      [text]="t('message')"
      [cancel]="t('buttons.cancel')"
      [confirm]="t('buttons.confirm')"
      (confirmedClick)="confirm()"
      (dismiss)="dismiss()"
      [size]="ModalSizeMap.sm"
    />
  }
</ng-container>
